import React,{ Component, Fragment, useState } from 'react';
import {useMutation, useQuery,withApollo} from 'react-apollo';
import {ADD_EDIT_PROJECT_VIDEO, GET_PROJECT_VIDEO,} from '../Queries/projectVideo';
import translate from '../../Translations/index';
import Notification from '../../../Library/notification';
import Loading from '../../../GlobalComponents/Loading';
import Helper from '../../../Library/helper';
import Error from '../../../GlobalComponents/Error';
import Modal from 'react-modal';
import ProjectVideosLib from '../Library/projectVideo';
import DatePicker,{ registerLocale } from 'react-datepicker';

const AddEditProjectVideo = (props) => {

    const projectVideos = new ProjectVideosLib(props);

    const [formData,setFormData] = useState({
        
        projectVideoID:props.selectedProjectVideoID,
        projectID: props.projectID,
        url:"",
        description:""
        
    });

    const {data:branchData,loading:getLoading,error:getError} = useQuery(GET_PROJECT_VIDEO,{
        variables:{
            projectVideoID: formData.projectVideoID
        },
        fetchPolicy: 'network-only',
        onCompleted(data){

            projectVideos.getData(data,formData.projectVideoID,formData,setFormData);
            
        },
    })

    const [addProjectVideo,{data:addBranchData,loading:addLoading,error:addError}] = useMutation(ADD_EDIT_PROJECT_VIDEO,{
        onCompleted(data){

			props.openCloseModal(false);
            
		},update(cache,response) {    
            
            projectVideos.updateList(cache,response,props.listVariables,formData.projectVideoID);
            
            let notify = new Notification();
            if(formData.projectVideoID && formData.projectVideoID != 0) notify.setNotification(cache,translate.t("SuccessfullySaved"),true,false);
            else notify.setNotification(cache,translate.t("SuccessfullyAdded"),true,false);

		},onError(err){
            const helper    = new Helper(); 
            err             = helper.getApolloErrorText(err);
            let notify      = new Notification();
            notify.setNotification(null,err,false,true,props.client);
        }
    })

    if(getError){
        const helper = new Helper(); 
        var error = "ERROR: " + helper.getApolloErrorText(getError)
    }

    return(
        <Modal
            className="Modal__Bootstrap modal-dialog modal-lg athlete-modal"
            closeTimeoutMS={150}
            isOpen={true}
            onRequestClose={() => props.openCloseModal(false)}
        >
            <div className="modal-content">
            <div className="modal-header d-flex align-items-center">
                    <h4 className="modal-title">{(formData.projectVideoID && formData.projectVideoID != 0 ? "Upravit fázi" : "Přidat fázi")}</h4>
                    <button athlete="button" className="close ml-3" onClick={() => props.openCloseModal(false)}>                                    
                        <span aria-hidden="true">x</span>
                        <span className="sr-only">Close</span>
                    </button>
                </div>
                <div className="modal-body">
                    {error ?
                        <Error text={error} />
                        :
                        <div>                            
                            {!getLoading && !addLoading ?
                                <Fragment>  
 
                                    <div className="row">    
                                                                            
                                    
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label className="input-label">*URL</label>
                                                <div className="form-group">
                                                    <input type="text" className="form-control" name="url" value={formData.url} onChange={(e) => projectVideos.formHandle(e,formData,setFormData)} />
                                                </div>
                                            </div>                                                 
                                        </div> 
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label className="input-label">Popis</label>
                                                <div className="form-group">
                                                    <input type="text" className="form-control" name="description" value={formData.description} onChange={(e) => projectVideos.formHandle(e,formData,setFormData)} />
                                                </div>
                                            </div>                                                
                                        </div> 
                       
                                    </div> 
                                        
                                </Fragment> 
                            :
                            <Loading />  
                            }  
                        </div>
                    }
                </div>
                <div className="modal-footer">                                
                    <button athlete="button" className="btn btn-primary flex-fill" onClick={() => projectVideos.addProjectVideo(addProjectVideo,formData)}>{(formData.projectVideoID && formData.projectVideoID != 0 ? translate.t("Edit") : translate.t("Add"))}</button>
                    <button athlete="button" className="btn btn-danger" onClick={() => props.openCloseModal(false)}>{translate.t("Close")}</button>
                </div>
            </div>
        </Modal>
    )

}

export default withApollo(AddEditProjectVideo);